<template>
  <div class="link rightBox">
    <div class="icon">
      <img src="https://fview.5kjs.com/activity/21sign/image/pc/linkMy.png" alt="" />
    </div>
    <div class="link_text">有问题？联系班主任</div>
    <div class="link_btn">
      <button @click="change()">立即联系</button>
    </div>
    <!-- 联系我们侧边悬浮框 -->
    <div class="link_methods" v-show="linkBox">
      <div class="wechat">
        <div class="img">
          <!-- <img src="@/assets/wechat.png" alt="" /> -->
          <i class="iconfont icon-weixin"></i>
        </div>
        <div class="ico_text">微信咨询</div>
        <div class="link_methods_oveflow">
          <div class="sanjiao"></div>
          <img :src="mykefu.weixin_qrcode" alt="二维码还没有上传噢~" />
        </div>
      </div>
      <div class="heng"></div>
      <div class="QQ">
        <div class="img">
          <!-- <img src="@/assets/QQ.png" alt="" /> -->
          <i class="iconfont icon-QQ"></i>
        </div>
        <div class="ico_text QQ_color">QQ咨询</div>
        <div class="qqlink_methods_oveflow">
          <div class="sanjiao"></div>
          <img :src="mykefu.qq_qrcode" alt="二维码还没有上传噢~" />
        </div>
      </div>
      <!-- 联系方式侧边悬浮框 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "linkTeacher",
  props: {
    mykefu: {
      type: Object,
      default: () => {
        return {
          mobile: "15201033560",
          name: "唐泽宇",
          qq_qrcode:
            "",
          weixin_qrcode:
            "",
        };
      },
    },
  },
  data() {
    return {
      linkBox: false,
    };
  },
  methods: {
    change() {
      this.linkBox = !this.linkBox;
    },
  },
};
</script>

<style lang="less" scoped>
.icon-weixin::before,
.icon-QQ:before {
  font-size: 1.875rem;
  color: #8b93a6;
}

// 联系我们部分
.link {
  position: relative;
  padding: 1.875rem;
  margin-bottom: 0 !important;
  overflow: visible;
  //联系我们溢出部分（侧边悬浮框）
  .link_methods {
    overflow: visible;
    position: absolute;
    right: -6rem - 1rem;
    bottom: 0;
    width: 6rem;
    height: 9.8125rem;
    background: #ffffff;
    box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .heng {
      margin: 0.75rem 0;
      width: 2.875rem;
      height: 0.0625rem;
      background: #eeeeee;
      border-bottom: 0.0625rem solid #eeeeee;
    }
    .wechat,
    .QQ {
      flex: 1;
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      .img {
        height: 1.3125rem;
        img {
          height: 100%;
        }
      }
      .ico_text {
        margin-top: 0.5rem;
        font-size: 0.75rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #8b93a6;
      }
      .QQ_color {
        color: #8b93a6;
      }
    }
    .wechat {
      justify-content: flex-end;
    }
    .wechat:hover {
      .ico_text {
        color: #ff8673;
      }
      .icon-weixin::before {
        color: #ff8673;
      }
      .link_methods_oveflow {
        display: block;
      }
    }

    .QQ:hover {
      .ico_text {
        color: #ff8673;
      }
      .icon-QQ:before {
        color: #ff8673;
      }
      color: #ff8673;
      .qqlink_methods_oveflow {
        display: block;
      }
    }
    //微信悬浮二维码部分
    .link_methods_oveflow {
      display: none;
      position: absolute;
      top: 0;
      right: -7.1875rem;
      width: 6.1875rem;
      height: 6.1875rem;
      background-color: #fff;
      box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      .sanjiao {
        z-index: 0;
        position: absolute;
        top: 50%;
        left: 0;
        height: 0.9375rem;
        width: 0.9375rem;
        background-color: #fff;
        transform: rotate(45deg) translateX(-50%);
        box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      }
      img {
        z-index: 10;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    // QQ悬浮
    .qqlink_methods_oveflow {
      display: none;
      position: absolute;
      bottom: 0;
      right: -7.1875rem;
      width: 6.1875rem;
      height: 6.1875rem;
      background-color: #fff;
      box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      .sanjiao {
        z-index: 0;
        position: absolute;
        top: 50%;
        left: 0;
        height: 0.9375rem;
        width: 0.9375rem;
        background-color: #fff;
        transform: rotate(45deg) translateX(-50%);
        box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      }
      img {
        z-index: 10;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }

  .icon {
    text-align: center;
    img {
      width: 5.125rem;
      height: 5.125rem;
    }
  }
  .link_text {
    margin: 1.375rem 0 2.5625rem;
    text-align: center;
    font-size: 1.5rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #424966;
    line-height: 1.375rem;
  }
  .link_btn {
    margin: auto;
    width: 9.75rem;
    height: 2.625rem;
    background: #ffffff;
    border: 0.0625rem solid #ffc2b4;
    border-radius: 0.25rem;
    button {
      height: 100%;
      width: 100%;
      border: none;
      font-size: 1.125rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #ff886d;
      line-height: 2.625rem;
      background-color: transparent;
      border-radius: 0.25rem;
    }
  }
}
.rightBox {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
  margin-bottom: 1.5rem;
}
.link_btn:hover {
  background: #ff8673;
  button {
    color: #fff;
  }
}
</style>